// extracted by mini-css-extract-plugin
export default {"thumbnail":"Thumbnail_thumbnail__hSj8S"};